import e from "react";
import { Text as n, Code as t, Divider as r, Link as a, Image as i, ListItem as l, Heading as c, UnorderedList as o, OrderedList as u, Checkbox as s } from "@chakra-ui/react";

function d() {
  return (d = Object.assign || function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];

      for (var r in t) {
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function m(e) {
  return e["data-sourcepos"] ? {
    "data-sourcepos": e["data-sourcepos"]
  } : {};
}

var h = {
  paragraph: function paragraph(t) {
    var r = t.children;
    return e.createElement(n, {
      mb: 2
    }, r);
  },
  emphasis: function emphasis(t) {
    var r = t.children;
    return e.createElement(n, {
      as: "em"
    }, r);
  },
  blockquote: function blockquote(n) {
    var r = n.children;
    return e.createElement(t, {
      p: 2
    }, r);
  },
  code: function code(n) {
    var r = n.language,
        a = n.value,
        i = r && "language-".concat(r);
    return e.createElement("pre", m(n), e.createElement(t, {
      p: 2,
      className: i || null
    }, a));
  },
  delete: function _delete(t) {
    var r = t.children;
    return e.createElement(n, {
      as: "del"
    }, r);
  },
  thematicBreak: r,
  link: a,
  img: i,
  linkReference: a,
  imageReference: i,
  text: function text(t) {
    var r = t.children;
    return e.createElement(n, {
      as: "span"
    }, r);
  },
  list: function list(n) {
    var t = n.start,
        r = n.ordered,
        a = n.children,
        i = n.depth,
        l = m(n);
    null !== t && 1 !== t && void 0 !== t && (l.start = t.toString());
    var c = o,
        s = "disc";
    return r && (c = u, s = "decimal"), 1 === i && (s = "circle"), e.createElement(c, d({
      spacing: 2,
      as: r ? "ol" : "ul",
      styleType: s,
      pl: 4
    }, l), a);
  },
  listItem: function listItem(n) {
    var t = n.children,
        r = n.checked,
        a = null;
    return null != r && (a = e.createElement(s, {
      isChecked: r,
      isReadOnly: !0
    }, t)), e.createElement(l, d({}, m(n), {
      listStyleType: null !== r ? "none" : "inherit"
    }), a || t);
  },
  definition: function definition() {
    return null;
  },
  heading: function heading(n) {
    var t = n.level,
        r = n.children;
    return e.createElement(c, d({
      my: 4,
      as: "h".concat(t),
      size: ["2xl", "xl", "lg", "md", "sm", "xs"]["".concat(t - 1)]
    }, m(n)), r);
  },
  inlineCode: function inlineCode(n) {
    var r = n.children;
    return e.createElement(t, m(n), r);
  }
};

function p() {
  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : h;
  return {
    paragraph: e.paragraph,
    emphasis: e.emphasis,
    blockquote: e.blockquote,
    code: e.code,
    delete: e.delete,
    thematicBreak: e.thematicBreak,
    link: e.link,
    img: e.img,
    linkReference: e.linkReference,
    imageReference: e.imageReference,
    text: e.text,
    list: e.list,
    listItem: e.listItem,
    definition: e.definition,
    heading: e.heading,
    inlineCode: e.inlineCode
  };
}

export default p;
export { h as defaults };